'use client'

import React from 'react'

type Props = {
    radius: number
}

const WIDTH = 340
const HEIGHT = 220

export default function HemisphereChart({ radius }: Props) {
    const r = 90
    const cx = WIDTH / 2
    const baseY = HEIGHT / 2 + 30
    const ry = r * 0.3

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            {/* dome */}
            <path d={`M ${cx - r} ${baseY} A ${r} ${r} 0 0 1 ${cx + r} ${baseY} Z`} fill="#2563eb" opacity={0.22} stroke="#2563eb" strokeWidth={2} />
            {/* curved latitude line */}
            <path d={`M ${cx - r} ${baseY} A ${r} ${r * 0.55} 0 0 1 ${cx + r} ${baseY}`} fill="none" stroke="#2563eb" strokeWidth={1.2} opacity={0.55} />
            {/* flat base ellipse */}
            <ellipse cx={cx} cy={baseY} rx={r} ry={ry} fill="#2563eb" opacity={0.28} stroke="#2563eb" strokeWidth={2} />
            {/* radius marker */}
            <line x1={cx} y1={baseY} x2={cx + r} y2={baseY} stroke="#dc2626" strokeWidth={1.5} />
            <text x={cx + r / 2} y={baseY + 18} fontSize={11} textAnchor="middle" fill="#dc2626">r = {radius.toFixed(2)}</text>
        </svg>
    )
}
